import React, { useState } from 'react';
import { getImageDimensions } from '@sanity/asset-utils';
import { urlForImageWithSize } from './image';

export default function SanityImage({ asset, size, style, ...props }) {
  const [isLoaded, setIsLoaded] = useState(false);
  const { width, height } = getImageDimensions(asset);
  const lqip = asset.metadata?.lqip;

  return (
    <img
      src={urlForImageWithSize(asset, size) || ''}
      width={width}
      height={height}
      onLoad={() => setIsLoaded(true)}
      style={{
        aspectRatio: width / height,
        ...(lqip && !isLoaded && { backgroundImage: `url(${lqip})`, backgroundSize: 'cover' }),
        ...style,
      }}
      {...props}
    />
  );
}
